var MuiRadio = {};
export default MuiRadio;
//# sourceMappingURL=MuiRadio.js.map